import { TimePicker } from 'element-ui'

const YTimePicker = TimePicker
YTimePicker.$depends = [TimePicker]
YTimePicker.$name = 'y-time-picker'
YTimePicker._name = 'TimePicker 时间选择器'

export default YTimePicker
